import { Col, ColType, Crud, CrudApi } from "../../comp/crud";
import { formatDate } from "../../utils";
import LeadImportHitDetail from "./indexHitDetail";
import { LeadImportHitProps } from "./indexHitDetail";

import { IconModalStroked } from "@douyinfe/semi-icons";
import { Modal, Typography } from "@douyinfe/semi-ui";

import React, { useEffect, useMemo, useState } from "react";

export default function LeadImportHit() {
  const [detailShow, setDetailShow] = useState(false);
  const [leadImportHitProps, setLeadImportHitProps] = useState(
    undefined as undefined | LeadImportHitProps
  );
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
  let cols: Col[] = [
    {
      name: "导入渠道",
      key: "source",
      hideInList: false,
      showInFilter: true,
      type: ColType.STRING,
    },

    {
      name: "撞库渠道",
      key: "hitSource",
      showInFilter: false,
      width:100,
      type: ColType.STRING,
    },
    {
      name: "撞库数",
      key: "hitCount",
      showInFilter: false,
      type: ColType.STRING,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadImportHitModal(record.source, record.hitSource);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "0星数",
      key: "hitStar0",
      showInFilter: false,
      type: ColType.STRING,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadImportHitModal(record.source, record.hitSource, 0);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "1星数",
      key: "hitStar1",
      showInFilter: false,
      type: ColType.STRING,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadImportHitModal(record.source, record.hitSource, 1);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "2星数",
      key: "hitStar2",
      showInFilter: false,
      type: ColType.STRING,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadImportHitModal(record.source, record.hitSource, 2);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "3星数",
      key: "hitStar3",
      showInFilter: false,
      type: ColType.STRING,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadImportHitModal(record.source, record.hitSource, 3);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "4星数",
      key: "hitStar4",
      showInFilter: false,
      type: ColType.STRING,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadImportHitModal(record.source, record.hitSource, 4);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "5星数",
      key: "hitStar5",
      showInFilter: false,
      type: ColType.STRING,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadImportHitModal(record.source, record.hitSource, 5);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
  ];
  const openLeadImportHitModal = async (source: string,hitSource: string, star?: number) => {
    let queryParams = crudApi?.getQueryParams();
    let p: LeadImportHitProps = {
      source: source,
      hitSource: hitSource,
      hitStar: star,
      ...queryParams,
    };
    setLeadImportHitProps(p);
    setDetailShow(true);
  };

  let nowDate = new Date();
  const initFilterValues = {
    //createdAt: [nowDate, nowDate],
  };

  let startDateStr = formatDate(nowDate);
  let endDateStr = formatDate(nowDate);
  const initParams = {
    //createdAt: startDateStr + "," + endDateStr,
  };

  return (
    <>
      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        title={"导入撞库明细"}
        fullScreen={true}
        headerStyle={{
          flexShrink: 0, // 关键属性 2：固定标题
          borderBottom: "1px solid var(--semi-color-border)",
        }}
        bodyStyle={{
          overflow: "auto", // 关键属性 3：启用内容滚动
          flex: 1,
        }}
        footer={null}
        hasCancel={false}
        onCancel={() => setDetailShow(false)}
        onOk={() => setDetailShow(false)}
        visible={detailShow}
      >
        <div>
          <LeadImportHitDetail
            source={leadImportHitProps?.source}
            hitSource={leadImportHitProps?.hitSource}
            leadName={leadImportHitProps?.leadName}
            leadMobile={leadImportHitProps?.leadMobile}
            createdAt={leadImportHitProps?.createdAt}
            hitStar={leadImportHitProps?.hitStar}
          />
        </div>
      </Modal>
      <Crud
        getCrudApi={(crudApi) => {
          setCrudApi(crudApi);
        }}
        canUpdate={false}
        canCreate={false}
        name="导入撞库统计"
        entityKey="leadImportLog/statLeadHitDataBySource"
        initFilterValues={initFilterValues}
        initParams={initParams}
        pageSize={500}
        cols={cols}
      />
    </>
  );
}
